module.exports = __webpack_public_path__ + "img/ie.6a6841f1.svg";